<img [src]="logo"
  class="logo"
  alt="SOH">